import React from 'react';
import { createPortal } from 'react-dom';

const multiplyFillKeyframes = `
@keyframes multiplyFillPP {
    0% { background-position: 100% 0; }
    100% { background-position: 0% 0; }
}
`;

const ProspectPrepLoadingModal = ({ open }) => {
    if (!open) return null;

    return createPortal(
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 10000,
            }}
        >
            <style>{multiplyFillKeyframes}</style>
            <div style={{
                background: '#fff',
                borderRadius: '10px',
                width: '90%',
                maxWidth: '520px',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
                overflow: 'hidden',
            }}>
                <div style={{ textAlign: 'center', padding: '50px 30px' }}>
                    <div style={{
                        fontFamily: 'Montserrat',
                        fontSize: '42px',
                        fontWeight: 800,
                        lineHeight: 1.4,
                        letterSpacing: '-1px',
                        padding: '4px 0',
                        background: 'linear-gradient(to right, #0784a7 50%, #d0d0d0 50%)',
                        backgroundSize: '200% 100%',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                        animation: 'multiplyFillPP 2.5s ease-in-out infinite alternate',
                        userSelect: 'none',
                        marginBottom: '24px'
                    }}>
                        Multiply
                    </div>
                    <p style={{
                        fontFamily: 'Montserrat',
                        fontSize: '14px',
                        color: '#666'
                    }}>
                        Murphy is reading your company profile and preparing objections...
                    </p>
                    <p style={{
                        fontFamily: 'Montserrat',
                        fontSize: '12px',
                        color: '#999'
                    }}>
                        This may take up to 2 minutes
                    </p>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default ProspectPrepLoadingModal;
